import React, { useEffect } from "react";
// import Dropdown from '../../components/globalComponents/dropdown/Dropdown'
import "./AttendanceStyle.css";
import PrimaryButton from "../../components/globalComponents/buttons/primaryButton/PrimaryButton";
import ProgressBar from "../../components/globalComponents/progressBar/ProgressBar";
import { lmsSliceData, getStuCourseAttendance } from "../../reducers/lmsSlice";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../components/globalComponents/PageLoader/PageLoader";
import { useNavigate } from "react-router-dom";
const Attendance = () => {
  const disptach = useDispatch();
  const navigate = useNavigate();
  const { isFetching, getStudentCourseAttendance } = useSelector(lmsSliceData);

  useEffect(() => {
    disptach(getStuCourseAttendance());
    // eslint-disable-next-line
  }, []);

  const getPercentage = (res) => {
    let data =
      res?.totalSessionHeldCount === 0
        ? 0
        : (res?.sessionAttendend / res?.totalSessionHeldCount) * 100;
    return data?.toFixed(2);
  };

  const singleCourseAttendance = (res) => {
    navigate(`/attendanceList?courseId=${res.courseId}`, {
      exact: true,
    });
  };

  return (
    <>
      {isFetching && <PageLoader />}
      <div className="attendaceOuter">
        <div className="pageHeader">
        <div className="backBtn" onClick={()=>navigate(-1)}>
          <img src="../assets/icons/back-btn.svg" alt="" />
          Back to Page
        </div>
         
          <div className="pageTogglers">
            <div className="pageToggler active">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.49996 3.95834C6.23431 3.95834 5.20829 4.98436 5.20829 6.25001C5.20829 7.51566 6.23431 8.54168 7.49996 8.54168C8.76561 8.54168 9.79163 7.51566 9.79163 6.25001C9.79163 4.98436 8.76561 3.95834 7.49996 3.95834ZM3.95829 6.25001C3.95829 4.294 5.54395 2.70834 7.49996 2.70834C9.45597 2.70834 11.0416 4.294 11.0416 6.25001C11.0416 8.20602 9.45597 9.79168 7.49996 9.79168C5.54395 9.79168 3.95829 8.20602 3.95829 6.25001ZM15.8333 2.70834C16.1785 2.70834 16.4583 2.98817 16.4583 3.33334V5.20834H18.3333C18.6785 5.20834 18.9583 5.48817 18.9583 5.83334C18.9583 6.17852 18.6785 6.45834 18.3333 6.45834H16.4583V8.33334C16.4583 8.67852 16.1785 8.95834 15.8333 8.95834C15.4881 8.95834 15.2083 8.67852 15.2083 8.33334V6.45834H13.3333C12.9881 6.45834 12.7083 6.17852 12.7083 5.83334C12.7083 5.48817 12.9881 5.20834 13.3333 5.20834H15.2083V3.33334C15.2083 2.98817 15.4881 2.70834 15.8333 2.70834ZM5.63986 11.875H9.36006C10.0374 11.875 10.5838 11.875 11.0262 11.9111C11.4817 11.9484 11.8818 12.027 12.252 12.2156C12.84 12.5152 13.3181 12.9933 13.6177 13.5813C13.8063 13.9515 13.8849 14.3516 13.9222 14.8071C13.9583 15.2495 13.9583 15.7959 13.9583 16.4732V17.5C13.9583 17.8452 13.6785 18.125 13.3333 18.125C12.9881 18.125 12.7083 17.8452 12.7083 17.5V16.5C12.7083 15.7896 12.7078 15.2944 12.6763 14.9089C12.6454 14.5307 12.5878 14.3134 12.5039 14.1488C12.3242 13.796 12.0373 13.5091 11.6845 13.3294C11.5199 13.2455 11.3026 13.1879 10.9244 13.157C10.5389 13.1255 10.0437 13.125 9.33329 13.125H5.66663C4.95625 13.125 4.46105 13.1255 4.07553 13.157C3.6973 13.1879 3.47999 13.2455 3.31539 13.3294C2.96259 13.5091 2.67575 13.796 2.49599 14.1488C2.41212 14.3134 2.35451 14.5307 2.32361 14.9089C2.29211 15.2944 2.29163 15.7896 2.29163 16.5V17.5C2.29163 17.8452 2.0118 18.125 1.66663 18.125C1.32145 18.125 1.04163 17.8452 1.04163 17.5L1.04163 16.4733C1.04162 15.7959 1.04161 15.2495 1.07776 14.8071C1.11498 14.3516 1.19361 13.9515 1.38223 13.5813C1.68184 12.9933 2.1599 12.5152 2.74791 12.2156C3.11809 12.027 3.51821 11.9484 3.97374 11.9111C4.41616 11.875 4.9625 11.875 5.63986 11.875Z"
                  fill="#262626"
                />
              </svg>
              Attendance
            </div>
          </div>
          <div></div>
        </div>
        <div className="attendaceContainerOuter">
          <div className="attendaceContainer">
            <div className="attendanceHeader">
              <div className="primaryTag">
                Total Attendance:{" "}
                {getStudentCourseAttendance?.AttendancePercentage === null ? 0 :getStudentCourseAttendance?.AttendancePercentage?.toFixed(2)}%
              </div>
              {/* <Dropdown/> */}
            </div>
            <div className="attendanceBody">
              {getStudentCourseAttendance?.Data?.length > 0 &&
                getStudentCourseAttendance?.Data?.map((res, i) => (
                  <div className="attendanceBox" key={i}>
                    <div className="attendanceBoxHeader">
                      <p className="heading">{res.courseName}</p>
                      <PrimaryButton
                        classname={"secondaryBtnSmall"}
                        children={"View All"}
                        onClick={() => singleCourseAttendance(res)}
                      />
                    </div>
                    <ProgressBar
                      color={"var(--success-4)"}
                      width={`${getPercentage(res)}%`}
                    />
                    <p className="percent">{getPercentage(res)}%</p>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Attendance;
